import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, Paragraph } from '@fs/zion-ui'

export default function NoRecordsOnTaskOverlay({ overlay, goBackToGive, getNewImage }) {
  const [t] = useTranslation()
  return (
    <DialogOverlay
      {...overlay}
      title={t('family-review.no-records-on-task-overlay.title', 'Whoops! There is nothing left to review')}
    >
      <Paragraph size="sm">
        <Trans i18nKey="family-review.no-records-on-task-overlay.content">
          <strong>Get another image</strong> or <strong>go back</strong> to Get Involved.
        </Trans>
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button
            onClick={goBackToGive}
            data-testid="no-records-on-task-overlay-close-button"
            linkName="No Records Go Back"
          >
            {t('family-review.no-records-on-task-overlay.go-back-button', 'Go Back')}
          </Button>
          <Button
            onClick={getNewImage}
            data-testid="no-records-on-task-overlay-new-task-button"
            emphasis="high"
            linkName="No Records Get New Image"
          >
            {t('family-review.no-records-on-task-overlay.new-image-button', 'Get Another Image')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
